import style from './Header.module.css';
import { useState } from 'react';

const Header = ({}) => {
  return <header className={style.header}>Mabu.pt</header>;
};

export default Header;
